import { render, staticRenderFns } from "./NotificationEmailLogs.vue?vue&type=template&id=5035e81d&scoped=true"
import script from "./NotificationEmailLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationEmailLogs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035e81d",
  null
  
)

export default component.exports